import { matchPath } from 'react-router';
import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import { getCurrentLocation } from 'selectors/router';

import { getRoot } from 'utils/selectors';

import { getReleaseById, getUIState } from '.';

const getDetailsUIState = createSelector(getUIState, state => state.details);

const getNoteModalUIState = createSelector(getUIState, state => state.noteModal);

const getNoteCsvModalUIState = createSelector(getUIState, state => state.noteCsvModal);

const getDetailsLoadingState = createSelector(getDetailsUIState, state => state.loading);

export const getSelectedReleaseId = createSelector(getCurrentLocation, location => {
  const match = matchPath(PATH.RELEASES_DETAILS.path, location);
  return match?.params?.releaseId;
});

export const isDetailsInitializing = createSelector(getDetailsLoadingState, state => state.initializing);

export const isUpdating = createSelector(getDetailsLoadingState, state => state.saving);

export const getDetailsRelease = createSelector(getRoot, getSelectedReleaseId, getReleaseById);

export const isDetailsReady = createSelector(
  getDetailsRelease,
  isDetailsInitializing,
  (release, initializing) => Boolean(release) && !initializing
);

export const isNoteModalOpen = createSelector(getNoteModalUIState, state => state.open);

export const isNoteCsvModalOpen = createSelector(getNoteCsvModalUIState, state => state.open);

export const isImporting = createSelector(getNoteCsvModalUIState, state => state.importing);

const getNoteModalReleaseId = createSelector(getNoteModalUIState, state => state.releaseId);

export const getSelectedNoteId = createSelector(getNoteModalUIState, state => state.noteId);

export const getNoteModalRelease = createSelector(getRoot, getNoteModalReleaseId, getReleaseById);

export const getEditingNote = createSelector(
  getNoteModalRelease,
  getSelectedNoteId,
  (release, selectedNoteId) => release?.notes?.find(({ id: noteId }) => noteId === selectedNoteId)
);
